<!-- Add Admin User Modal -->
<div class="modal centerModalNew fade in" id="adminUser" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog ">
    <div class="modal-content">    
    
    
    <!-- Modal body -->
    <div class="modal-body changeimagebody">
        <div class="common billingform ">
            <div class="changeimagediv text-center mr-top-60">
                
                <form [formGroup]="admin_fg" (ngSubmit)="admin_submit($event)" id="admin_user_form">
                    <h6 class="sucssheading clrgry text-left">Add Admin User</h6>
                    <div class="row">
                        <div class="form-group col-md-6">
                            <input formControlName="firstname" id="firstname" type="text"  class="form-control" placeholder="First name">
                            <div *ngIf="adminSubmitted && admin_fg_control.firstname.invalid">
                                <span class="inputValidation" *ngIf="admin_fg_control.firstname.errors.required">First name is required.</span>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input formControlName="lastname"  id="lastname" type="text"  class="form-control" placeholder="Last name">
                            <div *ngIf="adminSubmitted && admin_fg_control.lastname.invalid">
                                <span class="inputValidation" *ngIf="admin_fg_control.lastname.errors.required">Last name is required.</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-md-12">
                            <input (keyup)="enterEmail($event)" formControlName="email"  id="email" type="email"  class="form-control" placeholder="Email address">
                            <div *ngIf="adminSubmitted && admin_fg_control.email.invalid">
                                <span class="inputValidation" *ngIf="admin_fg_control.email.errors.required">Email address is required.</span>
                            </div>
                            <span class="inputValidation">{{emailerror}}</span>
                        </div>
                    </div>
                    
    
                    <div class="common changenumberbttn text-left">
                        <button class="savebttn">Submit</button>
                        <button class="cancelbttn close_a_admin" data-dismiss="modal" (click) ="adminModalClose()">Close</button>
                      </div>
                      <div class="common text-success sccsmsgdiv" >{{adminmessage}}</div>
                </form>
    
            </div>
        </div>
    
    </div>
    
    
    
    </div>
    </div>
    </div>